import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/itinerary'

export const itineraryService = {
    saveItem,
    saveAllItems,
    updateItem,
    updateAllItems,
    deleteItem,
    getItem,
    search,
};

//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert: false })
}

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

function saveAllItems(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/saveAll`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

function updateAllItems(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/updateAll`, 'POST', { data: data });
}

//delete
function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{})
}
